import { render, staticRenderFns } from "./UpgradeVersion.vue?vue&type=template&id=f085e840&"
import script from "./UpgradeVersion.vue?vue&type=script&lang=js&"
export * from "./UpgradeVersion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports